import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-politique-confidentialite',
  templateUrl: './politique-confidentialite.component.html',
  styleUrls: ['./politique-confidentialite.component.scss']
})
export class PolitiqueConfidentialiteComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
